import { useEffect } from 'react';
import { history } from 'umi';
// 组件
import { notification } from 'antd';
// 方法
import { getLocalStorage, removeLocalStorage } from '@/utils/utils';
// api
import { putUpdateEmail_api } from '@/api/user';

const UpdateAccount = () => {
  const putUpdateEmail = async (params: any) => {
    const res: any = await putUpdateEmail_api(params);
    if (res.success) {
      notification.success({
        message: 'User Email modified successfully',
      });
      removeLocalStorage('cdnControl-token');
      history.push('/user/login');
    }
  };

  useEffect(() => {
    const { query } = history.location;
    const { token } = query as { token: string };
    if (query && token) {
      const params = {
        newEmail: query?.newEmail,
        oldEmail: query?.oldEmail,
        code: query?.token,
      };
      putUpdateEmail(params);
    } else if (getLocalStorage('cdnControl-token')) {
      // history.push('/home');
      // window.location.reload();
      window.location.href = `${location.origin}${'/home'}`;
    }
  }, []);
  return <></>;
};
export default UpdateAccount;
